import Choices from 'choices.js';

const getPlaceholder = (selectElement) => {
  const fieldName = (selectElement.getAttribute('name') || '').toLowerCase();

  if (fieldName.includes('settoreid')) {
    return 'Seleziona una o piu Aree professionali';
  }

  if (fieldName.includes('paeseid')) {
    return 'Seleziona uno o piu Paesi';
  }

  return 'Seleziona una o piu opzioni';
};

const getVisibleLabelsLimit = (selectElement) => {
  const configuredLimit = Number.parseInt(selectElement.dataset.visibleLabels || '', 10);

  if (Number.isInteger(configuredLimit) && configuredLimit > 0) {
    return configuredLimit;
  }

  return 3;
};

const updateSelectionLabel = (selectElement, choicesContainer, placeholderText, visibleLabelsLimit) => {
  const selectedOptions = Array.from(selectElement.selectedOptions || [])
    .map((optionElement) => optionElement.textContent?.trim())
    .filter(Boolean);

  let labelText = placeholderText;

  if (selectedOptions.length === 1) {
    labelText = selectedOptions[0];
  }

  if (selectedOptions.length > 1 && selectedOptions.length <= visibleLabelsLimit) {
    labelText = selectedOptions.join(', ');
  }

  if (selectedOptions.length > visibleLabelsLimit) {
    labelText = `${selectedOptions.length} selezionati`;
  }

  choicesContainer.setAttribute('data-selection-label', labelText);
  choicesContainer.classList.toggle('has-selection', selectedOptions.length > 0);
};

export const initAnnunciFiltersSelect = () => {
  const form = document.querySelector('.annunci-filters__form');

  if (!form) {
    return;
  }

  const selectBindings = [];

  form.querySelectorAll('select[multiple]').forEach((selectElement) => {
    const placeholder = getPlaceholder(selectElement);
    const visibleLabelsLimit = getVisibleLabelsLimit(selectElement);

    let choicesInstance = selectElement._annunciChoicesInstance;

    if (selectElement.dataset.choicesInitialized !== 'true') {
      choicesInstance = new Choices(selectElement, {
        shouldSort: false,
        searchEnabled: false,
        removeItemButton: false,
        renderSelectedChoices: 'always',
        itemSelectText: '',
        placeholder: true,
        placeholderValue: placeholder,
        loadingText: 'Caricamento...',
        noResultsText: 'Nessun risultato',
        noChoicesText: 'Nessuna opzione disponibile',
      });
    }

    const choicesContainer = selectElement.closest('.choices');

    if (choicesContainer) {
      updateSelectionLabel(selectElement, choicesContainer, placeholder, visibleLabelsLimit);

      if (selectElement.dataset.choicesInitialized !== 'true') {
        selectElement.addEventListener('change', () => updateSelectionLabel(selectElement, choicesContainer, placeholder, visibleLabelsLimit));

        // In modalita button-like, permettiamo di deselezionare cliccando di nuovo
        // una voce gia selezionata nel dropdown.
        choicesContainer.addEventListener('mousedown', (event) => {
          const clickedChoice = event.target instanceof Element ? event.target.closest('.choices__item--selectable') : null;

          if (!clickedChoice || !clickedChoice.classList.contains('is-selected')) {
            return;
          }

          const choiceValue = clickedChoice.getAttribute('data-value');

          if (!choiceValue) {
            return;
          }

          event.preventDefault();
          choicesInstance.removeActiveItemsByValue(choiceValue);
          selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      selectBindings.push({
        selectElement,
        choicesInstance,
        choicesContainer,
        placeholder,
        visibleLabelsLimit,
      });
    }

    selectElement._annunciChoicesInstance = choicesInstance;
    selectElement.dataset.choicesInitialized = 'true';
  });

  const clearButton = form.querySelector('.annunci-filters__btn-clear');

  if (clearButton && clearButton.dataset.clearBound !== 'true') {
    clearButton.addEventListener('click', () => {
      selectBindings.forEach(({ selectElement, choicesInstance, choicesContainer, placeholder, visibleLabelsLimit }) => {
        if (choicesInstance) {
          choicesInstance.removeActiveItems();
        }

        Array.from(selectElement.options).forEach((optionElement) => {
          optionElement.selected = false;
        });

        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        updateSelectionLabel(selectElement, choicesContainer, placeholder, visibleLabelsLimit);
      });

      // Ensure backend user state is explicitly reset for both filters.
      [
        'filter_paeseId',
        'filter_settoreId',
        'filter[paeseId]',
        'filter[settoreId]',
      ].forEach((fieldName) => {
        const existingHidden = form.querySelector(`input[type="hidden"][name="${fieldName}"][data-clear-field="true"]`);

        if (existingHidden) {
          existingHidden.value = '';
          return;
        }

        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = fieldName;
        hiddenField.value = '';
        hiddenField.dataset.clearField = 'true';
        form.appendChild(hiddenField);
      });

      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    clearButton.dataset.clearBound = 'true';
  }
};